// extracted by mini-css-extract-plugin
export default {"padModal":"styles-module__padModal__qVS6O"};